import { GET } from "../../API/get";
import { POST } from "../../API/post";
import { requestForToken } from "../../firebase";

export const submitLogin = async ({email, password}) => {
    const response = await POST("customer-login", {
        customer_email: email,
        customer_password: password
    });

    if (response.status === "Success") {
        return {
            status: "Success",
            data: {
                customer_id: response.customer_id,
                customer_name: response.customer_name,
                customer_contact_number: response.customer_contact_number,
                customer_profile_image: response.customer_profile_image,
                customer_firebase_document_id: response.customer_firebase_document_id,
                token: response.token,
                refreshToken: response.refreshToken,
                is_have_pre_auth_card: response.is_have_pre_auth_card,
                customer_is_approved_terms_and_conditions: response.customer_is_approved_terms_and_conditions
            }
        };
    } else {
        return { status: "Failed", message: response.message };
    }
}

export const firebaseWebTokenRegister = async (customer_id) => {
    const customer_firebase_web_token = await requestForToken();

    const response = await POST("customer-firebase-web-token-register", {
        customer_id: customer_id,
        customer_firebase_web_token: customer_firebase_web_token
    });

    return response.status === "Success" ? response : null;
}

export const getCustomerSettings = async () => {
    const response = await GET("customer/settings");
    return response.status === "Success" ? response : null;
}

export const getCustomerLatestJob = async (customer_id) => {
    const response = await GET(`customer/latest/job/${customer_id}`);
    return response.status === "Success" ? response : null;
}

export const sendForgotPasswordEmail = async (email) => {
    const response = await POST("customer-reset-password", {
        customer_email: email
    });

    return response.status === "Success" ? response : null;
};